/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDirectoryResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfDirectoryResponseFromDiscriminatorValue, serializeDirectoryCreateRequest, serializeDirectoryResponse, type DirectoryCreateRequest, type DirectoryResponse, type HttpValidationProblemDetails, type IError, type PaginatedResultOfDirectoryResponse } from '../models/index.js';
// @ts-ignore
import { ArchivedRequestBuilderRequestsMetadata, type ArchivedRequestBuilder } from './archived/index.js';
// @ts-ignore
import { DirectoryItemRequestBuilderNavigationMetadata, DirectoryItemRequestBuilderRequestsMetadata, type DirectoryItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { PathRequestBuilderNavigationMetadata, PathRequestBuilderRequestsMetadata, type PathRequestBuilder } from './path/index.js';
// @ts-ignore
import { PinnedRequestBuilderRequestsMetadata, type PinnedRequestBuilder } from './pinned/index.js';
// @ts-ignore
import { RootRequestBuilderRequestsMetadata, type RootRequestBuilder } from './root/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /directories
 */
export interface DirectoriesRequestBuilder extends BaseRequestBuilder<DirectoriesRequestBuilder> {
    /**
     * The archived property
     */
    get archived(): ArchivedRequestBuilder;
    /**
     * The path property
     */
    get path(): PathRequestBuilder;
    /**
     * The pinned property
     */
    get pinned(): PinnedRequestBuilder;
    /**
     * The root property
     */
    get root(): RootRequestBuilder;
    /**
     * Gets an item from the ApiSdk.directories.item collection
     * @param directoryId Unique identifier of the item
     * @returns {DirectoryItemRequestBuilder}
     */
     byDirectoryId(directoryId: Guid) : DirectoryItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfDirectoryResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<DirectoriesRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfDirectoryResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DirectoryResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: DirectoryCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DirectoryResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<DirectoriesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: DirectoryCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface DirectoriesRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
    search?: string;
}
/**
 * Uri template for the request builder.
 */
export const DirectoriesRequestBuilderUriTemplate = "{+baseurl}/directories{?page*,pageSize*,search*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DirectoriesRequestBuilderNavigationMetadata: Record<Exclude<keyof DirectoriesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byDirectoryId: {
        requestsMetadata: DirectoryItemRequestBuilderRequestsMetadata,
        navigationMetadata: DirectoryItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["directory%2Did"],
    },
    archived: {
        requestsMetadata: ArchivedRequestBuilderRequestsMetadata,
    },
    path: {
        requestsMetadata: PathRequestBuilderRequestsMetadata,
        navigationMetadata: PathRequestBuilderNavigationMetadata,
    },
    pinned: {
        requestsMetadata: PinnedRequestBuilderRequestsMetadata,
    },
    root: {
        requestsMetadata: RootRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const DirectoriesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DirectoriesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfDirectoryResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: DirectoriesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDirectoryResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDirectoryCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
